import type { ID } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'

export const selectRelatedThreads =
  (id: ID, showResolved: boolean, selected: ID | null) => (state: AppState) =>
    state.manager.threads
      .filter((t) => t.commentable === id)
      .filter((t) => showResolved || !t.resolved || t.uuid === selected)

export const selectThreads = (state: AppState) => state.manager.threads

export const selectThread = (id: ID) => (state: AppState) =>
  state.manager.threads.find((t) => t.uuid === id)
